import * as VerificationTypes from 'services/access/modules/PhoneVerificationModule/PhoneVerificationModule.types';
import { ApiHelper } from 'utils/apiHelper';

const BASE_URL = 'user/verification/phone';

export const PhoneVerificationApi = {
    loadPhoneForward(params) {
        return ApiHelper.rpcCall<VerificationTypes.VerificationApiPhoneForward>(
            {
                url: `${BASE_URL}/forward`,
                method: 'POST',
                data: params,
            },
        );
    },

    codeConfirm(params) {
        return ApiHelper.rpcCall({
            url: `${BASE_URL}/confirm`,
            method: 'POST',
            data: params,
        });
    },
};
